export default {
  getFormList: {
    method: "get",
    url: "/form-service/v1/internal/forms/basic-info",
  },
  getFormById: {
    method: "get",
    url: "/form-service/v1/internal/forms/:id",
  },
  getFormBySchemaId: {
    method: "get",
    url: "/form-service/v1/internal/forms/:id/schema",
  },
  getFormByCodeAndVersion: {
    method: "get",
    url: "/form-service/v1/internal/forms/:code/:version",
  },
  getFormBasicInfo: {
    method: "get",
    url: "/form-service/v1/internal/forms/:code/basic-info",
  },
  createForm: {
    method: "post",
    url: "/form-service/v1/internal/forms",
  },
  createNewFormVersions: {
    method: "post",
    url: "/form-service/v1/internal/forms/:code/versions",
  },
  updateForm: {
    method: "put",
    url: "/form-service/v1/internal/forms/:id",
  },
  deleteForm: {
    method: "delete",
    url: "/form-service/v1/internal/forms/:code",
  },
};
